import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [recentBookings, setRecentBookings] = useState([]);

  const testimonials = [
    {
      id: 1,
      name: "Budi Santoso",
      location: "Jakarta Selatan",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 5,
      service: "Perbaikan AC",
      problem: "AC rumah tidak dingin sama sekali, padahal baru beli 2 tahun lalu",
      solution: "Teknisinya datang tepat waktu, ternyata ada kebocoran freon. Diperbaiki dengan profesional.",
      result: "Sekarang AC kembali dingin seperti baru. Hemat listrik juga!",
      savings: "Rp 800.000",
      date: "2 minggu lalu"
    },
    {
      id: 2,
      name: "Siti Nurhaliza",
      location: "Jakarta Pusat",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      rating: 5,
      service: "Cuci AC",
      problem: "AC kantor bau tidak sedap dan udara tidak segar",
      solution: "Tim datang dengan peralatan lengkap, cuci total indoor dan outdoor unit.",
      result: "Udara jadi segar, tidak bau lagi. Karyawan jadi lebih nyaman kerja.",
      savings: "Rp 300.000",
      date: "1 minggu lalu"
    },
    {
      id: 3,
      name: "Ahmad Wijaya",
      location: "Jakarta Timur",
      avatar: "https://randomuser.me/api/portraits/men/56.jpg",
      rating: 5,
      service: "Bongkar Pasang AC",
      problem: "Pindah rumah, butuh bongkar pasang 3 unit AC",
      solution: "Proses bongkar dan pasang sangat hati-hati, tidak ada yang rusak.",
      result: "Semua AC berfungsi normal di rumah baru. Pelayanan memuaskan!",
      savings: "Rp 1.200.000",
      date: "3 hari lalu"
    },
    {
      id: 4,
      name: "Rina Kartika",
      location: "Jakarta Barat",
      avatar: "https://randomuser.me/api/portraits/women/28.jpg",
      rating: 5,
      service: "Perbaikan AC",
      problem: "AC kamar anak berisik sekali, mengganggu tidur",
      solution: "Teknisi mengecek dan mengganti bearing fan yang sudah aus.",
      result: "AC jadi sunyi, anak bisa tidur nyenyak lagi. Terima kasih!",
      savings: "Rp 450.000",
      date: "5 hari lalu"
    }
  ];

  const mockRecentBookings = [
    { name: "Pak Joko", location: "Kebayoran", time: "5 menit", service: "Perbaikan AC" },
    { name: "Bu Sari", location: "Menteng", time: "12 menit", service: "Cuci AC" },
    { name: "Pak Dedi", location: "Kelapa Gading", time: "18 menit", service: "Bongkar Pasang" },
    { name: "Bu Maya", location: "Pondok Indah", time: "25 menit", service: "Perbaikan AC" },
    { name: "Pak Rudi", location: "Cempaka Putih", time: "31 menit", service: "Cuci AC" }
  ];

  useEffect(() => {
    setRecentBookings(mockRecentBookings);

    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleWhatsAppTestimonial = (testimonial) => {
    const message = `Halo, saya tertarik dengan layanan ${testimonial?.service} seperti yang dialami ${testimonial?.name}. Mohon info lebih lanjut.`;
    window.open(`https://wa.me/6282226648077?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="testimoni" className="py-16 lg:py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="MessageSquare" size={16} className="mr-2" />
            Testimoni Pelanggan
          </div>
          <h2 className="font-heading font-bold text-3xl lg:text-5xl text-foreground mb-6">
            Apa Kata Pelanggan Kami?
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Ribuan pelanggan telah merasakan layanan AC terpercaya kami.
            Baca pengalaman mereka dan jadilah yang berikutnya!
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Testimonial */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-card border border-border">
              {/* Header */}
              <div className="flex flex-col sm:flex-row items-center sm:justify-between gap-4 mb-6">
                <div className="flex items-center w-full sm:w-auto">
                  <img
                    src={testimonials?.[activeTestimonial]?.avatar}
                    alt={testimonials?.[activeTestimonial]?.name}
                    className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover mr-4"
                  />
                  <div className="flex-1">
                    <h3 className="font-heading font-bold text-lg sm:text-xl text-foreground">
                      {testimonials?.[activeTestimonial]?.name}
                    </h3>
                    <div className="flex flex-wrap items-center text-muted-foreground text-sm">
                      <Icon name="MapPin" size={14} className="mr-1" />
                      {testimonials?.[activeTestimonial]?.location}
                      <span className="mx-2 hidden sm:inline">•</span>
                      <span className="block w-full sm:w-auto sm:inline">{testimonials?.[activeTestimonial]?.date}</span>
                    </div>
                  </div>
                </div>
                <div className="w-full sm:w-auto">
                  <div className="flex items-center justify-center sm:justify-end mb-2">
                    {[...Array(testimonials?.[activeTestimonial]?.rating)]?.map((_, i) => (
                      <Icon key={i} name="Star" size={16} className="text-accent fill-current" />
                    ))}
                  </div>
                  <div className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-semibold text-center">
                    {testimonials?.[activeTestimonial]?.service}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="space-y-4">
                <div className="bg-destructive/5 rounded-xl p-4">
                  <h4 className="font-semibold text-foreground mb-2 flex items-center">
                    <Icon name="AlertCircle" size={16} className="text-destructive mr-2" />
                    Masalah yang Dialami:
                  </h4>
                  <p className="text-muted-foreground text-sm sm:text-base">"{testimonials?.[activeTestimonial]?.problem}"</p>
                </div>

                <div className="bg-primary/5 rounded-xl p-4">
                  <h4 className="font-semibold text-foreground mb-2 flex items-center">
                    <Icon name="Wrench" size={16} className="text-primary mr-2" />
                    Solusi yang Diberikan:
                  </h4>
                  <p className="text-muted-foreground text-sm sm:text-base">"{testimonials?.[activeTestimonial]?.solution}"</p>
                </div>

                <div className="bg-secondary/5 rounded-xl p-4">
                  <h4 className="font-semibold text-foreground mb-2 flex items-center">
                    <Icon name="CheckCircle" size={16} className="text-secondary mr-2" />
                    Hasil yang Didapat:
                  </h4>
                  <p className="text-muted-foreground text-sm sm:text-base">"{testimonials?.[activeTestimonial]?.result}"</p>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-4 border-t border-border">
                  <div className="text-center">
                    <div className="text-xl sm:text-2xl font-heading font-bold text-accent">
                      {testimonials?.[activeTestimonial]?.savings}
                    </div>
                    <div className="text-sm text-muted-foreground">Penghematan vs kompetitor</div>
                  </div>
                  <button
                    onClick={() => handleWhatsAppTestimonial(testimonials?.[activeTestimonial])}
                    className="bg-secondary text-white px-6 py-3 rounded-lg font-semibold hover:bg-secondary/90 transition-colors flex items-center justify-center w-full sm:w-auto"
                  >
                    <Icon name="MessageCircle" size={16} className="mr-2" />
                    Konsultasi Seperti Ini
                  </button>
                </div>
              </div>
            </div>

            {/* Testimonial Navigation */}
            <div className="flex items-center justify-center mt-6 space-x-2">
              {testimonials?.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${activeTestimonial === index ? 'bg-primary' : 'bg-border'
                    }`}
                />
              ))}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6 sticky top-24">
            {/* Recent Bookings */}
            <div className="bg-white rounded-2xl p-6 shadow-card border border-border">
              <h3 className="font-heading font-bold text-lg text-foreground mb-4 flex items-center">
                <Icon name="Clock" size={20} className="text-primary mr-2" />
                Pemesanan Terbaru
              </h3>
              <div className="space-y-3">
                {recentBookings?.slice(0, 4)?.map((booking, index) => (
                  <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                    <div>
                      <div className="font-semibold text-sm text-foreground">{booking?.name}</div>
                      <div className="text-xs text-muted-foreground">{booking?.location}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-xs text-primary font-semibold">{booking?.time} lalu</div>
                      <div className="text-xs text-muted-foreground">{booking?.service}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>



            {/* Google Reviews Link */}
            <div className="bg-white rounded-2xl p-6 shadow-card border border-border text-center">
              <Icon name="Star" size={32} className="text-accent mx-auto mb-3" />
              <h3 className="font-heading font-bold text-foreground mb-2">
                Lihat Semua Review
              </h3>
              <p className="text-sm text-muted-foreground mb-4">
                Baca 100+ review di Google
              </p>
              <button
                onClick={() => window.open('https://g.page/r/CfiHK8bCflMXEBE/review', '_blank')}
                className="w-full bg-accent text-white py-2 rounded-lg font-semibold hover:bg-accent/90 transition-colors"
              >
                Buka Google Reviews
              </button>
            </div>
          </div>
        </div>
        <div className="mt-16 max-w-2xl mx-auto text-center"> {/* Added margin-top and max-width for centering */}
          {/* Stats */}
          <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl p-6">
            <h3 className="font-heading font-bold text-lg text-foreground mb-4 text-center">
              Statistik Kepuasan
            </h3>
            <div className="flex flex-col sm:flex-row justify-around items-center gap-4">
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-primary mb-1">98.5%</div>
                <div className="text-sm text-muted-foreground">Tingkat Kepuasan</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-secondary mb-1">250+</div>
                <div className="text-sm text-muted-foreground">Pelanggan Puas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-accent mb-1">4.9/5</div>
                <div className="text-sm text-muted-foreground">Rating Google</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;